import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stats-list position-relative z-1" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-3 col-sm-6" }
const _hoisted_4 = { class: "col-lg-3 col-sm-6" }
const _hoisted_5 = { class: "col-lg-3 col-sm-6" }
const _hoisted_6 = { class: "col-lg-3 col-sm-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Appointments = _resolveComponent("Appointments")!
  const _component_Patients = _resolveComponent("Patients")!
  const _component_Operations = _resolveComponent("Operations")!
  const _component_Earnings = _resolveComponent("Earnings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Appointments)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Patients)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Operations)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Earnings)
      ])
    ])
  ]))
}